import * as Yup from 'yup'

import { REG_EXP_PASSWORD_REQUIREMENT } from '../../../../constants/regExp'

import {
  CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES,
  CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD,
  CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS,
  CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED,
} from './CreatePasswordForm.constants'

export function isCreatePasswordFormValidationErrorPasswordIsNotEqual(error) {
  return error === CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL
}

export function isCreatePasswordFormValidationErrorPasswordIsNotMatchRequirements(
  error
) {
  return (
    error ===
    CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS
  )
}

export function isCreatePasswordFormValidationErrorRulesAreNotAccepted(error) {
  return error === CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED
}

export function getCreatePasswordFormValidationSchema() {
  return Yup.object({
    [CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES]: Yup.boolean().oneOf(
      [true],
      CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED
    ),
    [CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD]: Yup.string()
      .required(true)
      .test(
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL,
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL,
        function (value, { parent }) {
          return (
            value === parent[CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD]
          )
        }
      )
      .test(
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS,
        CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS,
        function (value) {
          return REG_EXP_PASSWORD_REQUIREMENT.test(value)
        }
      ),
    [CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD]:
      Yup.string().required(true),
  })
}

export function getCreatePasswordFormPayload(values) {
  return { password: values[CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD] }
}
